import React from "react";
import { connect } from "react-redux";
import "./ArticleEditAudioListItem.css";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import Col from "react-bootstrap/Col";
import audioIcon from "../../assets/audio-icon.svg";
import {
  snapShotEditArticleContentAction,
  recoverLastEditArticleContentAction,
  updateArticleContentTextAction,
  saveArticleAction
} from "../../redux/actions/editArticlePanel";
import SelectableEditText from "../SelectableEditText/SelectableEditText";

class ArticleEditAudioListItem extends React.Component {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
  }

  onTextChange(event) {
    const {
      articleID,
      item,
      updateArticleContentTextAction,
      saveArticleAction
    } = this.props;

    updateArticleContentTextAction({ id: item.id, text: event.target.value });
    saveArticleAction(articleID);
  }

  focus() {
    const { item, snapShotEditArticleContentAction } = this.props;
    this.text = item.text;

    snapShotEditArticleContentAction();
  }

  blur() {
    const { item, recoverLastEditArticleContentAction } = this.props;

    if (this.text === item.text) {
      recoverLastEditArticleContentAction();
    }

    this.text = null;
  }

  render() {
    const { item } = this.props;

    return (
      <Card.Body style={{ paddingTop: "0", paddingBottom: "0" }}>
        <Row>
          <Col style={{ padding: "5px" }}>
            <Image style={{ maxWidth: "100%" }} src={audioIcon} />
          </Col>
          <Col style={{ padding: "15px" }}>
            {item.media.title}
            <hr />
            {item.media.description}
          </Col>
        </Row>
        <Row>
          <Col style={{ padding: "5px" }}>
            <SelectableEditText
              onFocus={this.focus}
              //onBlur={this.blur}
              value={item.text}
              onChange={this.onTextChange}
            />
          </Col>
        </Row>
      </Card.Body>
    );
  }
}

const mapDispatch = {
  snapShotEditArticleContentAction,
  recoverLastEditArticleContentAction,
  updateArticleContentTextAction,
  saveArticleAction
};

export default connect(
  null,
  mapDispatch
)(ArticleEditAudioListItem);
